<nav class="navbar navbar-expand-lg mb-2 border-bottom bg-body-tertiary">
  <div class="container-fluid">
    <a class="navbar-brand" href="">
      <img src="abc-groep-logo.svg" alt="abc" height="30" />
      TimeHub
    </a>

    <button
      class="navbar-toggler"
      type="button"
      aria-controls="navbarNavAltMarkup"
      [attr.aria-expanded]="menuOpen()"
      (click)="toggleMenu()"
      i18n-aria-label="
        accessible label|Accessible label for the button to toggle the navigation
        menu@@toggleNavigationAriaLabel"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div
      class="collapse navbar-collapse justify-content-between"
      id="navbarNavAltMarkup"
      [ngbCollapse]="!menuOpen()"
    >
      <div class="navbar-nav">
        <a
          class="nav-link"
          routerLink=""
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="closeMenu()"
          i18n="nav link|Navigation link to the home page of the application@@navHome"
        >
          Timesheets
        </a>
        <a
          class="nav-link"
          routerLink="upload"
          routerLinkActive="active"
          (click)="closeMenu()"
          i18n="nav link|Navigation link to the file upload page@@navUpload"
        >
          Upload
        </a>
        <a
          class="nav-link"
          routerLink="preferences"
          routerLinkActive="active"
          (click)="closeMenu()"
          i18n="nav link|Navigation link to the user preferences page@@navPreferences"
        >
          Preferences
        </a>

        @if (isPoweruser() && !isImpersonating()) {
          <a
            class="nav-link"
            routerLink="manage"
            routerLinkActive="active"
            (click)="closeMenu()"
            i18n="nav link|Navigation link to the management page for privileged users@@navManage"
          >
            Manage
          </a>
          <a
            class="nav-link"
            routerLink="inspect"
            routerLinkActive="active"
            (click)="closeMenu()"
            i18n="nav link|Navigation link to the inspect page for privileged users@@navInspect"
          >
            Inspect
          </a>
          <a
            class="nav-link"
            routerLink="sync"
            routerLinkActive="active"
            (click)="closeMenu()"
            i18n="nav link|Navigation link to the sync settings page@@navSync"
          >
            Sync
          </a>
        }
        @if (isPoweruser()) {
          <a
            class="nav-link"
            routerLink="impersonation"
            routerLinkActive="active"
            (click)="closeMenu()"
            i18n="
              nav link|Navigation link to the impersonation page for privileged
              users@@navImpersonation"
          >
            Impersonation
          </a>
        }
        <a
          class="nav-link"
          routerLink="help"
          routerLinkActive="active"
          (click)="closeMenu()"
          i18n="nav link|Navigation link to the help settings page@@navHelp"
        >
          Help
        </a>
      </div>
      <div class="d-flex flex-row-reverse flex-md-row justify-content-between gap-3 mt-2 mt-md-0">
        <abc-language-selector />
        <abc-user-dropdown />
      </div>
    </div>
  </div>
</nav>
